import { toast } from "react-toastify";

  export const handleCopyLicenseInfo = (license , customer) => {
    const isGastora = String(license?.LisansKey || "").startsWith("GST");
    const licenseInfo = isGastora
      ? `
Müşteri: ${customer.Unvan}
Ürün: Gastro
Lisans Key: ${license.LisansKey || "Belirtilmemiş"}
Lisans Numarası: ${customer.MusteriNo || "Belirtilmemiş"}
Lisans Tipi: ${license.LisansTipi || "Belirtilmemiş"}
Kurulum: ${
  String(license.KurulumTipi || "").toUpperCase() === "CLOUD"
    ? "Bulut Sunucu"
    : String(license.KurulumTipi || "").toUpperCase() === "LOCAL"
      ? "Yerel Sunucu"
      : license.KurulumTipi || "Belirtilmemiş"
}
Kullanıcı Sayısı: ${license.MaxKullaniciSayisi ?? license.UserCount ?? "Belirtilmemiş"}
Başlangıç Tarihi: ${license.BaslangicTarih ? new Date(license.BaslangicTarih).toLocaleDateString("tr-TR") : "Belirtilmemiş"}
Bitiş Tarihi: ${license.BitisTarih ? new Date(license.BitisTarih).toLocaleDateString("tr-TR") : "Belirtilmemiş"}
Modüller: ${[
  license.moduleQrMenu && "QR Menü",
  license.moduleRestoran && "Restoran",
  license.modulePaketServis && "Paket Servis",
  license.moduleUretim && "Üretim",
].filter(Boolean).join(", ") || "—"}
      `.trim()
      : `
Müşteri: ${customer.Unvan}
Lisans Numarası: ${customer.MusteriNo}
Lisans Tipi: ${license.LisansTipi}
Client ID: ${license.UserNo}
Kullanıcı Sayısı: ${license.UserCount || "Belirtilmemiş"}
Başlangıç Tarihi: ${new Date(license.BaslangicTarih).toLocaleDateString("tr-TR")}
Bitiş Tarihi: ${new Date(license.BitisTarih).toLocaleDateString("tr-TR")}
    `.trim();

    // Fallback çözümü
    const copyToClipboard = (text) => {
      try {
          // Modern yöntem
          if (navigator.clipboard && window.isSecureContext) {
              return navigator.clipboard.writeText(text)
                  .then(() => true)
                  .catch(() => false);
          }

          // Fallback yöntemi
          const textArea = document.createElement("textarea");
          textArea.value = text;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          try {
              document.execCommand('copy');
              textArea.remove();
              return Promise.resolve(true);
          } catch (err) {
              textArea.remove();
              return Promise.resolve(false);
          }
      } catch (err) {
          return Promise.resolve(false);
      }
  };

  copyToClipboard(licenseInfo)
      .then((success) => {
          if (success) {
              toast.success("Lisans bilgileri kopyalandı!");
          } else {
              toast.error("Lisans bilgileri kopyalanamadı.");
          }
      });
};
